<template>
  <person-info></person-info>
</template>
<script>
import personInfo from './components/personInfo'

export default {
  name: 'addPerson',
  data() {
    return {}
  },

  methods: {},
  components: {
    personInfo
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped></style>
